export const FlowProviderName = {
    storehub: 'storehub',
    lazada: 'lazada',
    shopee: 'shopee',
    minipos: 'minipos',
};
